import { render, staticRenderFns } from "./add.vue?vue&type=template&id=206fb38c&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206fb38c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206fb38c')) {
      api.createRecord('206fb38c', component.options)
    } else {
      api.reload('206fb38c', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=206fb38c&scoped=true", function () {
      api.rerender('206fb38c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/account/add.vue"
export default component.exports